<template>
  <section class="points-exchange-page mt-4">
    <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
    <app-page-header title="Troca de pontos por BRITZ"></app-page-header>

    <div v-if="!hasFinished" class="boxes-container">
      <div class="box">
        <h1>Quantos pontos deseja trocar?</h1>
        <p>
          Ao escolher a troca por produtos, seus pontos serão convertidos em
          saldo para uso exclusivo na loja virtual, não havendo a possibilidade
          de utilização fora da loja.
        </p>
        <app-input type="number" v-model="tradePoints" />
        <button
          :disabled="!isValid"
          @click="onSubmit()"
          type="button"
          v-app-button
        >
          RESGATAR AGORA
        </button>
        <p>
          Ao clicar no botão de resgate acima, estou de acordo com o
          <a
            href="https://www.clubevendaeganhe.com.br/files/termos/termo_quitacao.pdf"
            >Termo de Adesão à Campanha e Uso do Cartão MAPIPrêmio.</a
          >
        </p>
      </div>
    </div>

    <div v-if="hasFinished" class="has-finished">
      <h1>Resgate realizado!</h1>
      <p>Acesse os sites para poder usufruir dos seus créditos!</p>

      <div>
        <a :href="philcoLink" target="_blank">
          <button type="button" v-app-button.secondary>
            Ir para Philco Club
          </button>
        </a>
      </div>

      <div>
        <a :href="britaniaLink" target="_blank">
          <button type="button" v-app-button>Ir para Britânia em Casa</button>
        </a>
      </div>

      <div>
        <router-link :to="{ name: 'site.index' }" class="home-link"
          >Voltar ao início</router-link
        >
      </div>
    </div>
  </section>
</template>

<script>
import RedemptionService from '@/services/redemption.service';
import { SUM_POINTS } from '@/store/actions/auth';

export default {
  name: 'points-exchange-page',
  data: () => {
    return {
      isLoading: false,
      isSubmitting: false,
      hasFinished: false,
      tradePoints: null,
      philcoLink: null,
      britaniaLink: null,
    };
  },
  computed: {
    points() {
      return this.$store.getters.userPoints;
    },
    isValid() {
      return this.tradePoints > 0 && this.tradePoints <= this.points;
    },
  },
  methods: {
    onSubmit() {
      if (this.isSubmitting) return;

      this.isSubmitting = true;
      this.isLoading = true;

      this.$buefy.dialog.confirm({
        message: this.tradePoints < 0 ? 'Tem certeza que deseja realizar o resgate ? <br><br> <b>Resgates menores que 50 pontos tem cobrança de taxa 1 ponto </b> <br> Ao clicar no botão <b>SIM</b>, estou de acordo com o <b>Termo de Adesão à Campanha</b> e as <b>Taxas</b> cobradas pela operação' : 'Tem certeza que deseja realizar o resgate ?',
        cancelText: 'Cancelar',
        confirmText: 'Sim',
        type: 'is-primary',
        onConfirm: () => this.submit(),
        onCancel: () => {
          this.isSubmitting = false;
          this.isLoading = false;
        },
      });
    },
    submit() {
      const points = this.tradePoints;

      RedemptionService.trade(points)
        .then(({ data }) => {
          const { philcoclub, britaniaemcasa } = data.links;
          this.philcoLink = philcoclub;
          this.britaniaLink = britaniaemcasa;

          this.hasFinished = true;
          this.$store.dispatch(SUM_POINTS, -points);
          this.toastify('Resgate concluído com sucesso!');

          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        })
        .catch(({ response }) => {
          const { status, data } = response;

          if (status === 429) {
            this.toastify(
              'Verificamos múltiplas tentativas consecutivas de resgate. Tente novamente mais tarde.',
              'error'
            );
          } else {
            this.toastify(data.message, 'error');
          }
        })
        .finally(() => {
          this.isLoading = false;
          this.isSubmitting = false;
        });
    },
  },
  mounted() {
    this.tradePoints = this.points;
  },
};
</script>

<style lang="scss" scoped>
section.points-exchange-page {
  .boxes-container {
    display: flex;
    justify-content: center;
    margin: 0 15vh;
  }

  .box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 2em;
    border-radius: 8px;
    border: 1px solid var(--color-secondary);
    box-shadow: none;
    max-width: 350px;
    margin-bottom: 0;

    h1 {
      font-size: 2em;
      font-weight: bold;
      text-align: center;
      margin-bottom: 1em;
    }

    button {
      margin-bottom: 1.5em;
    }

    p {
      font-size: 1em;
      font-family: var(--font-family-secondary);
      text-align: center;
      color: var(--text-color-light);
    }
  }
}

.has-finished {
  text-align: center;

  h1 {
    font-size: 2rem;
    font-family: var(--font-family-secondary);
    font-weight: bold;
    color: var(--color-primary);
  }

  p {
    font-size: 1.2rem;
    color: var(--text-color-light);
    margin-bottom: 32px;
  }

  > div {
    margin-bottom: 12px;
  }
}

@media (max-width: 992px) {
  section.points-exchange-page {
    padding: 0 1em;
    .boxes-container {
      margin: 0;
    }
  }
}
</style>
